import React from "react";

const MainModalHeader = ({ header, icon, goBackAction, closeModalHandler }) => {
    return (
        <>
            <div className="modal-header flex items-center justify-between">
                {goBackAction && (
                    <i
                        className="fas fa-chevron-left fa-2xs mr-4 cursor-pointer text-primary-color-blue"
                        onClick={goBackAction}
                    />
                )}
                <header className="main-model-form-header main-content-header flex items-center">
                    {icon && <i className={`${icon}`}></i>}
                    <h3>{header}</h3>
                </header>
                {closeModalHandler && (
                    <div
                        onClick={closeModalHandler}
                        className="icon-wrapper ml-auto mt-1"
                    >
                        <i className="fas fa-times" />
                    </div>
                )}
            </div>
        </>
    );
};

export default MainModalHeader;
